export default __webpack_public_path__ + "static/02-a484e3cde2592b4a8fd98d29631dee09.mp4";